module.exports = __webpack_public_path__ + "static/media/ins18.7eec4a17.jpg";